module.exports = __webpack_public_path__ + "static/ideation-eb1af248c6d5ea6edb51115db5d13d2f.png";